import React from "react";
import { ReviewItem } from "../molecules/ReviewItem";
import styled from "styled-components";

/**
 * 참여할 리뷰 상세 (리뷰 응답 폼)
 * - 일반 사용자용 화면
 */
const ReviewForm = ({ ...props }) => {
    const { reviewDetailData, stateValue } = props;

    return (
        <CustomReviewForm>
            <div className="title-wrap">
                <h2>{reviewDetailData.title}</h2>
                <div className="title-desc">{reviewDetailData.description}</div>
            </div>

            <div className="item-wrap">
                {reviewDetailData.question.map((el, elIdx) => {
                    return <ReviewItem key={el.idx} idx={elIdx} data={el} stateValue={stateValue} />
                })}
            </div>
        </CustomReviewForm>
    );
};

const CustomReviewForm = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 25px;

    .title-wrap {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .item-wrap {
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
`;

export default ReviewForm;